{
  "assignment": {
    "defaultTitle": "Envía tu actividad",
    "maxFilesError_one": "Máximo de {{count}} archivo permitido",
    "maxFilesError_zero": "Máximo de {{count}} archivos permitidos",
    "maxFilesError_other": "Máximo de {{count}} archivos permitidos",
    "fileTooLarge": "{{name}} es demasiado grande. Máximo: {{size}}MB",
    "fileUploaded": "¡{{name}} subido correctamente!",
    "fileUploadError": "Error al subir {{name}}",
    "addAtLeastOne": "Añade al menos un archivo",
    "waitAllUploads": "Espera a que se suban todos los archivos",
    "submitted": "¡Actividad enviada correctamente!",
    "submitError": "Error al enviar la actividad",
    "dropHere": "Suelta los archivos aquí...",
    "clickOrDrag": "Haz clic o arrastra archivos aquí",
    "limits_one": "Máximo {{count}} archivo, {{size}}MB cada uno",
    "limits_zero": "Máximo {{count}} archivos, {{size}}MB cada uno",
    "limits_other": "Máximo {{count}} archivos, {{size}}MB cada uno",
    "acceptedTypes": "Tipos aceptados: {{types}}",
    "filesCount": "Archivos ({{total}})",
    "status": {
      "completed": "Subido",
      "error": "Error",
      "uploading": "Subiendo..."
    },
    "commentsLabel": "Comentarios (opcional)",
    "commentsPlaceholder": "Añade comentarios sobre tu actividad...",
    "hint": {
      "empty": "Añade archivos para continuar",
      "waiting": "Espera a que termine la subida",
      "ready": "¡Listo para enviar!",
      "errors": "Algunos archivos no se pudieron subir"
    },
    "submitting": "Enviando...",
    "submit": "Enviar actividad"
  },
  "download": {
    "defaultTitle": "Materiales para descargar",
    "fileType": {
      "code": "Código",
      "file": "Archivo"
    },
    "downloaded": "¡{{name}} descargado correctamente!",
    "error": "Error al descargar el archivo",
    "startingAll": "Iniciando la descarga de todos los archivos...",
    "status": {
      "downloading": "Descargando...",
      "completed": "¡Descargado!",
      "error": "Error",
      "idle": "Descargar"
    },
    "downloadAll": "Descargar todos",
    "tips": {
      "title": "💡 Consejos de descarga",
      "programs": "• Algunos archivos pueden necesitar programas específicos para abrirse",
      "organize": "• Mantén tus materiales organizados en una carpeta del curso",
      "zip": "• Los archivos ZIP contienen varios archivos comprimidos",
      "code": "• Los archivos de código se pueden abrir en editores como VS Code"
    }
  },
  "pdf": {
    "loaded_one": "PDF cargado: {{count}} página",
    "loaded_zero": "PDF cargado: {{count}} páginas",
    "loaded_other": "PDF cargado: {{count}} páginas",
    "loadErrorDescription": "Error al cargar el PDF. Verifica que el archivo sea válido.",
    "loadError": "Error al cargar el PDF",
    "downloadStarted": "¡Descarga iniciada!",
    "downloadPdf": "Descargar PDF",
    "defaultTitle": "Documento PDF",
    "pages_one": "{{count}} página",
    "pages_zero": "{{count}} páginas",
    "pages_other": "{{count}} páginas",
    "download": "Descargar",
    "exitFullscreen": "Salir",
    "fullscreen": "Pantalla completa",
    "pageOf": "{{page}} de {{total}}",
    "loading": "Cargando PDF...",
    "navigationHint": "Usa las flechas ← → para moverte entre las páginas"
  },
  "richText": {
    "readingCompleted": "📖 ¡Lectura completada!",
    "readingCompletedDescription": "Has leído todo el contenido de esta clase.",
    "copied": "¡Contenido copiado!",
    "defaultTitle": "Contenido de la clase",
    "preparingPrint": "Preparando para imprimir...",
    "readTime": {
      "lessThanOne": "Menos de 1 min",
      "one": "1 min",
      "many": "{{minutes}} min"
    },
    "percentRead": "{{percent}}% leído",
    "hide": "Ocultar",
    "show": "Mostrar",
    "copy": "Copiar",
    "print": "Imprimir",
    "progress": "Progreso:",
    "endOfContent": "Fin del contenido"
  },
  "video": {
    "embedLoadError": "No se pudo cargar el video. Verifica el enlace de la clase.",
    "downloadNotAllowed": "Descarga no permitida",
    "actionBlocked": "Acción bloqueada por seguridad",
    "lessonCompleted": "¡Clase completada!",
    "lessonCompletedDescription": "¡Felicidades! Viste la clase completa.",
    "invalidId": "ID de video no válido",
    "expectedFormat": "Formato esperado: 24 caracteres hexadecimales"
  },
  "media": {
    "invalidImageType": "Tipo de archivo no válido. Usa JPG, PNG, GIF o WebP.",
    "invalidVideoType": "Tipo de archivo no válido. Usa MP4, WebM, MOV o AVI."
  }
}
